import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {AppDispatch, RootState} from "../../store";
import {fetchDocuments, fetchDocumentTypes, fetchPropertyTypes} from "../documents/documentsThunks";

/**
 * Thunk, инициализирующий приложение:
 *  1) Загружает DocumentTypes
 *  2) Загружает PropertyTypes
 *  3) Загружает список документов (Light)
 */
export const initializeApp = createAsyncThunk<void, void, { dispatch: AppDispatch; state: RootState }>(
    'app/initializeApp',
    async (_, { dispatch }) => {
        // 1) Загружаем DocumentTypes
        await dispatch(fetchDocumentTypes({ })).unwrap();
        // 2) Загружаем PropertyTypes
        await dispatch(fetchPropertyTypes({ })).unwrap();
        // 3) Загружаем список документов (light)
        await dispatch(fetchDocuments()).unwrap()
    }
);

interface AppState {
    initialized: boolean; // Флаг, что все нужные данные загружены
    initializing: boolean; // Процесс инициализации (чтобы показывать Splash)
    error: string | null;
}

const initialState: AppState = {
    initialized: false,
    initializing: false,
    error: null
};

const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        // Могут быть вспомогательные редьюсеры, если нужно
    },
    extraReducers: (builder) => {
        builder
            .addCase(initializeApp.pending, (state) => {
                state.initializing = true;
                state.error = null;
            })
            .addCase(initializeApp.fulfilled, (state) => {
                state.initializing = false;
                state.initialized = true;
            })
            .addCase(initializeApp.rejected, (state, action) => {
                state.initializing = false;
                state.error = action.error.message || 'Ошибка инициализации приложения';
            });
    },
});

export default appSlice.reducer;
